<template>
  <div>
    <el-form :model="form" ref="form" class="table-search-bar" inline label-width="70px">
      <el-form-item label="产品大类" prop="categoryName">
        <el-input v-model="form.categoryName" placeholder="请输入产品大类"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="itemName">
        <el-input v-model="form.itemName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品编码" prop="itemCode">
        <el-input v-model="form.itemCode" placeholder="请输入商品编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="listData"
      tooltip-effect="light"
      style="width: 100%"
     >
      <el-table-column
        label="产品大类"
        prop="categoryName"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="产品"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleProductLook(scope.$index, scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            v-permission="'0031300601'"
            size="mini"
            @click="handleProductLook(scope.$index, scope.row, 'edit')">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <product-dialog v-if="productDialogShow" :info="editInfo" :isEdit="isEdit" @update:handleProductClose="handleProductClose"/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import ProductDialog from './../productDialog'

export default {
  name: 'ProductCategories',
  components: { ProductDialog },
  data () {
    return {
      form: {
        categoryName: '',
        itemName: '',
        itemCode: ''
      },
      listState: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      listData: [],
      productDialogShow: false,
      isEdit: false
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getProductList']),
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.getProductList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.getProductList({ pageNo: val, pageSize: 10 })
    },
    handleSearch () {
      const params = {
        ...this.form,
        ...this.listState
      }
      this.getProductList(params).then(res => {
        this.listData = res.list || []
        this.total = res.total
        this.listState.pageNo = res.pageNum
        this.listState.pageSize = res.pageSize
      })
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleProductLook (index, row, val) {
      if (val === 'edit') {
        this.isEdit = true
      } else {
        this.isEdit = false
      }
      this.editInfo = row
      this.productDialogShow = true
    },
    handleProductClose (playload) {
      let { productDialogShow } = playload
      this.productDialogShow = productDialogShow
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
